import { render, staticRenderFns } from "./ProductLots.vue?vue&type=template&id=59075a81&scoped=true"
import script from "./ProductLots.vue?vue&type=script&lang=js"
export * from "./ProductLots.vue?vue&type=script&lang=js"
import style0 from "./ProductLots.vue?vue&type=style&index=0&id=59075a81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59075a81",
  null
  
)

export default component.exports